import { EntityBase, Var } from "addeus-common-library/stores/firestore";

export class AIStats extends EntityBase {
    @Var(Number)
    requests: number = 0;

    @Var(Number)
    inputTokens: number = 0;

    @Var(Number)
    outputTokens: number = 0;
}

export class AnalysedData extends EntityBase {
    @Var(Number)
    points?: number;

    @Var(Number)
    maxPoints?: number;

    @Var(String)
    comment?: string;
}

export class PublicationsAudit extends EntityBase {
    @Var(AnalysedData)
    publicationFrequency?: AnalysedData;

    @Var(AnalysedData)
    visualQuality?: AnalysedData;

    @Var(AnalysedData)
    formatVariety?: AnalysedData;

    @Var(AnalysedData)
    contentOptimization?: AnalysedData;

    @Var(AnalysedData)
    hashtagQuality?: AnalysedData;

    @Var(AnalysedData)
    contentQuality?: AnalysedData;

    @Var(AnalysedData)
    humanPresence?: AnalysedData;

    @Var(AnalysedData)
    contentInteraction?: AnalysedData;

    get score(): number {
        return (
            (this.publicationFrequency?.points ?? 0) * 2.5 +
            (this.visualQuality?.points ?? 0) * 2.5 +
            (this.formatVariety?.points ?? 0) * 2 +
            (this.contentOptimization?.points ?? 0) * 2 +
            (this.hashtagQuality?.points ?? 0) * 1.5 +
            (this.contentQuality?.points ?? 0) * 2 +
            (this.humanPresence?.points ?? 0) * 2.5 +
            (this.contentInteraction?.points ?? 0) * 2.5
        );
    }

    get maxScore(): number {
        return (
            (this.publicationFrequency?.maxPoints || 0) * 2.5 +
            (this.visualQuality?.maxPoints || 0) * 2.5 +
            (this.formatVariety?.maxPoints || 0) * 2 +
            (this.contentOptimization?.maxPoints || 0) * 2 +
            (this.hashtagQuality?.maxPoints || 0) * 1.5 +
            (this.contentQuality?.maxPoints || 0) * 2 +
            (this.humanPresence?.maxPoints || 0) * 2.5 +
            (this.contentInteraction?.maxPoints || 0) * 2.5
        );
    }
}

export class CommunityAudit extends EntityBase {
    @Var(AnalysedData)
    engagement?: AnalysedData;

    @Var(AnalysedData)
    targetAudience?: AnalysedData;

    @Var(AnalysedData)
    followersEvolution?: AnalysedData;

    get score(): number {
        return (
            (this.engagement?.points ?? 0) * 2 +
            (this.targetAudience?.points ?? 0) * 2.3 +
            (this.followersEvolution?.points ?? 0) * 2.3
        );
    }

    get maxScore(): number {
        return (
            (this.engagement?.maxPoints ?? 0) * 2 +
            (this.targetAudience?.maxPoints ?? 0) * 2.3 +
            (this.followersEvolution?.maxPoints ?? 0) * 2.3
        );
    }
}

export class ProfileAudit extends EntityBase {
    @Var(AnalysedData)
    pictureQuality?: AnalysedData;

    @Var(AnalysedData)
    pictureVisibility?: AnalysedData;

    @Var(AnalysedData)
    bioEmoji?: AnalysedData;

    @Var(AnalysedData)
    bioKeywords?: AnalysedData;

    @Var(AnalysedData)
    bioStructure?: AnalysedData;

    @Var(AnalysedData)
    bioMission?: AnalysedData;

    @Var(AnalysedData)
    bioOriginality?: AnalysedData;

    @Var(AnalysedData)
    bioLink?: AnalysedData;

    get score(): number {
        return (
            ((this.pictureQuality?.points || 0) +
                (this.pictureVisibility?.points || 0) +
                (this.bioEmoji?.points || 0) +
                (this.bioKeywords?.points || 0) +
                (this.bioStructure?.points || 0) +
                (this.bioMission?.points || 0) +
                (this.bioOriginality?.points || 0) +
                (this.bioLink?.points || 0)) *
            0.6
        );
    }

    get maxScore(): number {
        return (
            ((this.pictureQuality?.maxPoints || 0) +
                (this.pictureVisibility?.maxPoints || 0) +
                (this.bioEmoji?.maxPoints || 0) +
                (this.bioKeywords?.maxPoints || 0) +
                (this.bioStructure?.maxPoints || 0) +
                (this.bioMission?.maxPoints || 0) +
                (this.bioOriginality?.maxPoints || 0) +
                (this.bioLink?.maxPoints || 0)) *
            0.6
        );
    }
}

export class SummaryAudit extends EntityBase {
    @Var(Array.of(String))
    goodPoints: string[] = [];

    @Var(Array.of(String))
    badPoints: string[] = [];
}
